import * as React from "react";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";

const Hero = () => {
  const headingRef = React.useRef<HTMLHeadingElement>(null);

  useGSAP(() => {
    gsap.fromTo(
      headingRef.current,
      { y: "100%" },
      {
        y: 0,
        duration: 1.5,
        delay: 0.075,
        ease: "power4",
      }
    );
  }, [headingRef]);

  return (
    <section className="relative pt-16">
      <div className="hero-heading overflow-hidden py-3.5 text-center">
        <h1 className="hero-text" ref={headingRef}>
          Blogs.
        </h1>
      </div>
    </section>
  );
};

export default Hero;
